import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'oval', 'Oval', [["path",{"d":"M6 12a6 9 0 1 0 12 0a6 9 0 1 0 -12 0"}]]);